import React from 'react';
import { testimonials } from '../../data/mock';
import { Quote } from 'lucide-react';

const TestimonialsSection = () => {
  return (
    <section className="py-24 px-6 bg-[#0f0f0f]">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-sm font-medium text-white/50 uppercase tracking-wider mb-4 block">
            Testimonials
          </span>
          <h2 className="heading-2 text-white mb-4">Loved by Creators & Brands</h2>
          <p className="body-medium text-[#737373] max-w-2xl mx-auto">
            See what our users have to say about automating their social presence.
          </p>
        </div>

        {/* Testimonials Grid - Bento Style */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-[#141414] border border-white/10 rounded-3xl p-8 hover:border-white/20 transition-all duration-300 relative"
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-6 text-white/10">
                <Quote size={32} />
              </div>

              {/* Content */}
              <p className="text-[#a3a3a3] leading-relaxed mb-6 pr-8">
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center text-[#0a0a0a] font-semibold">
                  {testimonial.avatar}
                </div>
                <div>
                  <p className="font-semibold text-white">{testimonial.name}</p>
                  <p className="text-sm text-[#737373]">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
